/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fac_Plan_DescInputs */

const en_fac_plan_desc = /** @type {(inputs: Fac_Plan_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For design-thinking coaches, capstone lecturers, and agencies who run structured Design Room workshops across workspaces.`)
};

const id_fac_plan_desc = /** @type {(inputs: Fac_Plan_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk pelatih design thinking, dosen capstone, dan agensi yang menjalankan workshop Design Room terstruktur lintas ruang kerja.`)
};

/**
* | output |
* | --- |
* | "For design-thinking coaches, capstone lecturers, and agencies who run structured Design Room workshops across workspaces." |
*
* @param {Fac_Plan_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fac_plan_desc = /** @type {((inputs?: Fac_Plan_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fac_Plan_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fac_plan_desc(inputs)
	return en_fac_plan_desc(inputs)
});